"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permission = void 0;
const permissions = {
    _title: "Everything",
    admin: {
        _title: "Administration",
        _description: "Administrative actions which affect the entire system.",
        departments: {
            _title: "Departments",
            _description: "Create and Modify Departments"
        },
        employee: {
            _title: "Employee Administration",
            _description: "Create and Modify Employees"
        },
        scheduleTemplates: {
            _title: "Schedule Templates",
            _description: "Manage schedule templates"
        }
    },
    manage: {
        _title: "Management",
        _description: "Management actions. Contains permissions to allow managers to review requests in the system.",
        employee: {
            _title: "Employee Basic",
            _description: "Basic admin functions around employees"
        },
        pto: {
            _title: "PTO",
            entries: {
                _title: "Entries",
                _description: "View, modify, or void employee PTO Entries"
            },
            requests: {
                _title: "Requests",
                _description: "View and review employee PTO Requests"
            },
            schedule: {
                _title: "Schedules",
                _description: "Manage employees PTO Earn Schedules"
            },
        }
    },
    usage: {
        _title: "Usage",
        _description: "Standard usage permission. Contains all standard employee functions.",
        basic: {
            _title: "Basic functions",
            _description: "Should be given to anyone who will use the app",
        },
        pto: {
            _title: "PTO",
            _description: "Allows a user to utilize the PTO system to request PTO and view their PTO."
        }
    },
    authentication: {
        _title: "Authentication Methods",
        _description: "Different ways to login",
        byEmail: { _title: "Email" },
        password: { _title: "Password" },
        cross: { _title: "Cross from App" },
    }
};
function makePermission(key, iPermission, parent) {
    const permission = {
        _title: iPermission._title,
        _description: iPermission._description,
        _parent: parent,
        _children: [],
        _key: key,
        includedIn(permissions) {
            if (permissions.indexOf(this._key) > -1)
                return true;
            else if (this._parent)
                return this._parent.includedIn(permissions);
            else
                return false;
        },
        allContained() {
            let permissions = [this];
            for (const sub of this._children)
                permissions = permissions.concat(sub.allContained());
            return permissions;
        }
    };
    for (const subKey of Object.keys(iPermission)) {
        if (subKey.startsWith("_"))
            continue;
        let sub;
        if (typeof iPermission[subKey] === "string")
            sub = makePermission(`${key}.${subKey}`, { _title: iPermission[subKey] }, permission);
        else
            sub = makePermission(`${key}.${subKey}`, iPermission[subKey], permission);
        permission[subKey] = sub;
        permission._children.push(sub);
    }
    return permission;
}
exports.Permission = makePermission("_", permissions, null);
//# sourceMappingURL=permission.js.map